import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import HeroBanner from '../components/hero-banner/hero-banner';
import { getWidget, registerWidget } from '../components/contentful-views/sections';

/**
 * HeroBanner for all the heroes out there (especially you).
 * https://app.contentful.com/spaces/ljtyf78xujn2/content_types/heroBanner/fields
 * @param {Object} props
 * @param {Object} props.model
 */
const HeroBannerWidget = ({ model }) => {
  const ctaButton = getWidget(get(model, 'fields.ctaButton'));
  const backgroundImage = get(model, 'fields.backgroundImage.fields.file.url');
  const backgroundImageMobile = get(model, 'fields.backgroundImageMobile.fields.file.url');
  const videos = get(model, 'fields.video');

  return (
    <HeroBanner
      {...model.fields}
      backgroundImage={backgroundImage}
      backgroundImageMobile={backgroundImageMobile}
      ctaButton={ctaButton}
      videos={videos}
    />
  );
};

HeroBannerWidget.propTypes = {
  model: PropTypes.shape({fields: PropTypes.shape({})}),
};

HeroBannerWidget.defaultProps = {
  model: {},
};

registerWidget('heroBanner', HeroBannerWidget);

export default HeroBannerWidget;
